import { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import { Text } from 'foundations-components/components/Text';
import { ONBOARDING_FORECAST_CATEGORY_TAB } from '../../constants/TourConstants';
import { REP_OVERVIEW } from '../../constants/Events';
import { trackCancelUITour, trackNextStepUITour } from '../../utils/usageTracker';
import { getIsDealStageView } from '../../selectors/forecastSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const OnboardingForecastCategoryTabTourStep = () => {
  const {
    tour
  } = useContext(TourContext);
  const isDealStageView = useSelector(getIsDealStageView);
  const handleBeforeNext = useCallback(() => {
    trackNextStepUITour(ONBOARDING_FORECAST_CATEGORY_TAB, REP_OVERVIEW, isDealStageView);
  }, [isDealStageView]);
  const handleCancelTour = useCallback(() => {
    trackCancelUITour(ONBOARDING_FORECAST_CATEGORY_TAB, REP_OVERVIEW, isDealStageView);
  }, [isDealStageView]);
  const tourKey = tour.getTour();
  if (!tourKey) {
    return null;
  }
  return /*#__PURE__*/_jsx(UITourStep, {
    tourKey: tourKey,
    stepKey: ONBOARDING_FORECAST_CATEGORY_TAB,
    attachTo: `[data-tour-step-key="${ONBOARDING_FORECAST_CATEGORY_TAB}"]`,
    showSteps: true,
    placement: "bottom",
    showCloseButton: true,
    onClickCloseButton: handleCancelTour,
    content: {
      header: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        color: "text-primary-on-fill-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "tour.onboarding.forecastCategoryTab.header"
        })
      }),
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "tour.onboarding.forecastCategoryTab.body"
      }),
      footer: /*#__PURE__*/_jsx(UIButtonWrapper, {
        children: /*#__PURE__*/_jsx(UITourNextButton, {
          beforeNext: handleBeforeNext,
          use: "primary",
          size: "small"
        })
      })
    }
  });
};
export default OnboardingForecastCategoryTabTourStep;